import { Provider } from 'react-redux'
import { ModalProvider } from '@leroy-merlin-br/backyard-react-ui'

import { useProfile } from 'catalog/hooks/use-profile'

import CartBody from 'checkout/components/Cart/Body'
import { configureStore } from 'checkout/redux/store'

import Header from './components/Header'
import * as S from './styled'

const store = configureStore()

const Cart = () => {
  const { profile } = useProfile()

  return (
    <Provider store={store}>
      <ModalProvider>
        <S.Container className="new-container">
          <Header regionName={profile.selectedRegionName} />
          <CartBody regionName={profile.selectedRegionName} regionInit={profile.region} />
        </S.Container>
      </ModalProvider>
    </Provider>
  )
}

export default Cart
